// exposes node_modules/pikaday
import Pikaday from 'pikaday';
window['Pikaday'] = Pikaday;
